/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_UntilInputs */

const cs_gdpr_audit_until = /** @type {(inputs: Gdpr_Audit_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const en_gdpr_audit_until = /** @type {(inputs: Gdpr_Audit_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Gdpr_Audit_UntilInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_until = /** @type {((inputs?: Gdpr_Audit_UntilInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_UntilInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_until(inputs)
	return cs_gdpr_audit_until(inputs)
});